import { Link } from "react-router";
import { HelpCircle } from "lucide-react";

/**
 * Dashboard library - quick-answer deep links into pre-filtered reports.
 * The "ready-made dashboards" one-click install used to live here too, but
 * it saved its reports into a browser-only list that never reached the
 * tenant's database, so a dashboard installed on one device silently broke
 * for the rest of the team. Hidden until saved reports persist for real.
 */

/** Hand-curated questions → pre-filtered report deep links (URL filters). */
const QUICK_ANSWERS: { q: string; to: string }[] = [
  { q: "Which channel drives the most closed-won revenue?", to: "/reports/attribution?model=last&dimension=channel&stage=won" },
  { q: "What started the journeys that became pipeline?", to: "/reports/attribution?model=first&dimension=source" },
  { q: "Which campaigns are actually creating deals?", to: "/reports/attribution?dimension=campaign" },
  { q: "How did we do last month?", to: "/reports/scorecard" },
  { q: "What are people searching to find us?", to: "/reports/web?source=gsc" },
  { q: "What is our ad spend returning?", to: "/reports/web?source=ads" },
];

export const DashboardLibraryTab = () => {
  return (
    <div className="flex flex-col gap-5">
      {/* Quick answers - each chip deep-links into a pre-filtered report */}
      <div className="flex flex-col gap-2">
        <p className="text-[10px] uppercase tracking-wide text-muted-foreground font-medium">
          Quick answers
        </p>
        <div className="flex flex-wrap gap-2">
          {QUICK_ANSWERS.map((q) => (
            <Link
              key={q.to}
              to={q.to}
              className="inline-flex items-center gap-1.5 rounded-full border border-border px-3 py-1.5 text-sm hover:border-primary/60 hover:bg-primary/5 transition-colors"
            >
              <HelpCircle className="w-3.5 h-3.5 text-muted-foreground" />
              {q.q}
            </Link>
          ))}
        </div>
      </div>

      <div className="flex flex-col gap-2">
        <p className="text-[10px] uppercase tracking-wide text-muted-foreground font-medium">
          Ready-made dashboards
        </p>
        <p className="text-sm text-muted-foreground max-w-2xl -mt-1">
          Temporarily unavailable - installing one saved its reports to a
          browser-only list that didn't carry over for the rest of your team,
          so this is off while that gets fixed properly.
        </p>
      </div>
    </div>
  );
};
